import { PropTypes } from "@material-ui/core";


export default class ConstantMessage {
    public static DefaultClearButtonText = "Clear";
    public static DefaultCreateButtonText = "Create";
    public static DefaultUpdateButtonText = "Update";
    public static DefaultDownloadButtonText = "Download"
    public static DefaultAssignButtonText = "ASSIGN"
    public static DefaultReceiveButtonText = "RECEIVE"
    public static DefaultColorPrimary: PropTypes.Color = "primary";
    public static DefaultColorDefault: PropTypes.Color = "default";
    public static DefaultColorSecondary: PropTypes.Color = "secondary";
    public static DefaultColorSuccess: PropTypes.Color = "primary";
    public static DefaultLogOutButtonText = "Log Out";


    public static DefaultConfirmBoxYesButtonText = "Yes";
    public static DefaultConfirmBoxNoButtonText = "No";

    public static ImageSomeIssueWithImageText = "Some issue with image";

    public static DropZoneAddFileText = "Drop or click to add files";

    public static LoginPagePath = "/login"

}